import SForm from './s-form.jsx'

SForm.install = function(Vue) {
  Vue.component(SForm.name, SForm)
}

export default SForm